<template>
  <div class="iqos-image-actions">
    <ImageUploader :class="{
      'w-100': fillSpace
    }" :image_type="type" @success="onUpload">
      <BaseButton :class="{
      'w-100': fillSpace
    }" variant="secondary" color="green-5" size="sm" icon="plus" />
    </ImageUploader>
    <BaseButton
      variant="secondary"
      color="orange-4"
      class="ml-4"
      size="sm"
      icon="edit-02"
      v-if="value"
    />
    <BaseButton
      variant="secondary"
      class="ml-4"
      color="red-4"
      size="sm"
      icon="trash"
      @click="onDelete"
      v-if="value"
    />
  </div>
</template>

<script>
import ImageUploader from "@/components/ImageUploader.vue"

export default {
    props: {
        value: String,
        defaultSize: {
            type: String,
            default: 'md'
        },
        type: {
            type: String,
            default: 'cafe'
        },
        fillSpace: {
          type: Boolean,
          default: false
        }
    },
    components: {
        ImageUploader
    },
    methods: {
        onUpload(sizes) {
            this.$emit('input', sizes[this.defaultSize] || sizes.original);
            this.$emit('change');
        },
        onDelete() {
            this.$emit('input', null);
            this.$emit('change');
        }
    }
};
</script>

<style scoped>
.iqos-image-actions {
    display: flex;
}
</style>
